import { types } from 'mobx-state-tree';

export default types
  .model('UsedLinksSummary', {
    created_at: types.maybe(types.string),
    alias: types.maybe(types.string),
    item_id: types.maybe(types.number),
    latest_created_at: types.maybe(types.string),
    latest_ip_address: types.maybe(types.string),
    mode: types.maybe(types.string),
    total_diff_ips: types.maybe(types.number),
    total_ips: types.maybe(types.number)
  })
  .views(self => ({
    get logo_src() {
      return `data:image/jpeg;base64,${self.logo}`;
    },
  }));
